import {
  resolveId,
  getCategoryIds,
  createAction,
} from '@wix/communities-blog-client-common';
import { pickDraftProps } from '@wix/communities-blog-universal/dist/src/post-utils';
import { sanitizeContent } from '@wix/communities-blog-universal/dist/src/utils/sanitize-content';
import { normalizePost } from '../services/post-utils';

export const UPDATE_POST_SUCCESS = 'post/DRAFT_UPDATE_SUCCESS';

const updatePostRequest = createAction('post/DRAFT_UPDATE_REQUEST');
const updatePostSuccess = createAction(UPDATE_POST_SUCCESS);
const updatePostFailure = createAction('post/DRAFT_UPDATE_FAILURE');

export function updatePost(post = {}) {
  return (dispatch, getState, { request }) => {
    dispatch(updatePostRequest());

    const promise = request.patch(`/_api/posts/${resolveId(post)}`, {
      draft: sanitizeContent(pickDraftProps(post)),
    });

    return promise
      .then((updatedPost) =>
        dispatch(
          updatePostSuccess(
            normalizePost({
              state: getState(),
              post: updatedPost,
              blogCategoryIds: getCategoryIds(getState()),
            }),
          ),
        ),
      )
      .catch(() => dispatch(updatePostFailure()))
      .then(() => promise);
  };
}
